import useCurrentResourceCentre from "./useCurrentResourceCentre";

const useIsSSFEnabled = (): { isSsfEnabled: boolean } => {
  const rc = useCurrentResourceCentre();

  return { isSsfEnabled: Boolean(rc?.subscriptions.features.ssf?.subscribed) };
};

export default useIsSSFEnabled;
